<template>
  <div class="content">
    <div class="header">
      <van-nav-bar title="订单支付" left-arrow @click-left="goBack" />
    </div>
    <p class="order">订单编号:{{ OrderNumber }}</p>
    <p>
      <span>￥{{ Number(money).toFixed(2) }}</span>
    </p>
    <div class="payFashion">
      <van-radio-group v-model="radio">
        <van-cell-group>
          <van-cell title="微信支付" clickable @click="radio = '2'">
            <img slot="icon" src="../../assets/img/icon/编组@2x(1).png" />
            <van-radio slot="right-icon" name="2" />
          </van-cell>
          <van-cell title="支付宝" clickable @click="radio = '1'">
            <img slot="icon" src="../../assets/img/icon/编组@2x.png" />
            <van-radio slot="right-icon" name="1" />
          </van-cell>
        </van-cell-group>
      </van-radio-group>
    </div>
    <van-button type="danger" round block @click="goToPayment"
      >立即支付</van-button
    >
  </div>
</template>
<script>
import checkDevice from "../../tools/app";
export default {
  data() {
    return {
      radio: "2",
      phone: "",
      OrderNumber: sessionStorage.getItem("PRODUCT_NUMBER"),
      money: this.$route.query.m,
    };
  },
  methods: {
    goToPayment() {
      sessionStorage.setItem("PRODUCT_MONEY", this.money);
      this.phone = checkDevice();
      let message = [this.radio, this.OrderNumber];
      if (this.phone == "ios" && this.radio == "2") {
        // IOS系统并且选择的是微信支付
        window.webkit.messageHandlers.jsCallOCFunction.postMessage(message);
      } else if (this.phone == "ios" && this.radio == "1") {
        // IOS系统并且选择的是支付宝支付
        window.webkit.messageHandlers.jsCallOCFunction.postMessage(message);
      } else if (this.phone == "android" && this.radio == "2") {
        // andriod系统并且选择的是微信支付
        window.jsCallAndroid.jsCallOCFunction(message);
      } else if (this.phone == "android" && this.radio == "1") {
        // andriod系统并且选择的是支付宝支付
        window.jsCallAndroid.jsCallOCFunction(message);
      } else {
        this.$toast.fail("手机系统未匹配支付");
        return false;
      }
    },
    goBack() {
      this.$dialog
        .confirm({
          title: "付款提示",
          message: "确认放弃付款吗？",
          cancelButtonText: "放弃",
          confirmButtonText: "继续支付",
        })
        .then(() => {
          // on confirm
        })
        .catch(() => {
          this.$toast("支付未完成");
          this.$router.push("/myOrder2");
        });
    },
  },
};
</script>
<style lang="less" scoped>
.content {
  width: 100%;
  height: 100%;
  position: relative;
  background-color: #f6f6f6;
  .header {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1;
    background-color: #fff;
    /deep/.van-nav-bar {
      background-color: #40000000;
      .van-nav-bar__text {
        color: #030303;
        font-size: 0.45rem;
      }
      /deep/.van-nav-bar__left {
        .van-icon {
          margin-top: 0.1rem;
          color: #030303;
          font-size: 0.533333rem;
        }
      }
      /deep/.van-nav-bar__title.van-ellipsis {
        font-weight: 500 !important;
      }
    }
  }
  p {
    padding-top: 0.5rem;
    text-align: center;
    font-size: 0.5rem;
    span {
      color: red;
      font-size: 0.8rem;
    }
  }
  .payFashion {
    width: 9.2rem;
    margin: 0 auto;
    margin-top: 1.5rem;
    background-color: #fff;
    .van-radio-group {
      .van-cell-group {
        .van-cell.van-cell--clickable {
          position: static;
          border-bottom: none;
          img {
            width: 0.81rem;
            height: 0.81rem;
            margin-right: 0.27rem;
            margin-top: 0.1rem;
          }
        }
      }
    }
    .van-cell {
      height: 1.5rem;
    }
    .van-cell__title {
      line-height: 1rem;
    }
  }
  .van-button {
    color: #ffffff;
    margin: 0 auto;
    width: 6.5rem;
    margin-top: 4rem;
  }
  .order {
    font-size: 0.37rem;
    padding-top: 2rem;
  }
}
</style>
